import { Pipe, PipeTransform } from '@angular/core';
import { formatPhone } from '../utility-functions';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  transform(rawPhone: string, parenthesis = false): string {
    return formatPhone(rawPhone, parenthesis);
  }
}
